export default "__VITE_ASSET__ZXHs4tM1__"